import React, { useEffect, useState } from "react";
import { Form, Button, Modal } from "antd";
import { ReactSVG } from "react-svg";

import ListContainer from "../../../modules/companyAdmin/containers/List";
import CompanyAdminsTable from "../../Table/CompanyAdmins";
import CompanyAdminForm from "../../Forms/CompanyAdmins/CompanyAdmin";
import withPage from "../withPage";
import { PAGE_SIZE } from "../../../constants";
import CompanyAdminsFilterForm from "../../Forms/Filters/CompanyAdmins";

const PartnerCompanyAdminsPage = ({
  isFetching,
  companyAdmins,
  companies,
  metadata,
  query,
  pushTo,
  doGetAllPartnerCompanies,
  doGetAllPartnerCompanyAdmins,
  doCreatePartnerCompanyAdmin,
  doUpdatePartnerCompanyAdmin,
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const [form] = Form.useForm();
  const currentPage = Number(query.currentPage) || 1;
  const itemsPerPage = Number(query.itemsPerPage) || PAGE_SIZE;
  const pagination = {
    current: currentPage,
    pageSize: itemsPerPage,
    total: metadata.totalItems,
    showTotal: total => `${total} Company Admins`,
  };
  const [state, setState] = useState({
    visibleModal: false,
    action: "",
    companyAdmin: null,
  });

  useEffect(() => {
    doGetAllPartnerCompanies({});
    doGetAllPartnerCompanyAdmins({ currentPage, itemsPerPage, ...query });
  }, []);

  const handleFilter = (params, updatePath) => {
    if (updatePath) {
      pushTo({ query: params });
    }
    const currentPage = Number(params.currentPage) || 1;
    const itemsPerPage = Number(params.itemsPerPage) || PAGE_SIZE;
    doGetAllPartnerCompanyAdmins({
      currentPage,
      itemsPerPage,
      ...params,
    });
  };

  const handleTableChange = params => {
    handleFilter(params, true);
    form.resetFields();
  };

  const withAction = item => {
    return (
      <div className="actions">
        <Button
          type="link"
          className="edit"
          onClick={() => {
            handleClickAction("edit", item);
          }}>
          <ReactSVG className="icon" src="/icons/edit.svg" />
        </Button>
      </div>
    );
  };

  const handleClickAction = (action, item) => {
    form.setFieldsValue({
      name: item?.name,
      email: item?.email,
      companies: item?.companies?.map(c => c.company._id),
      password: null,
      passwordDefault: false,
    });
    setState({
      ...state,
      action,
      companyAdmin: item,
      visibleModal: true,
    });
  };

  const handleOnFinish = async values => {
    if (state.companyAdmin) {
      await doUpdatePartnerCompanyAdmin({
        id: state.companyAdmin._id,
        ...values,
        password: values.password || null,
      });
    } else {
      await doCreatePartnerCompanyAdmin(values);
      await doGetAllPartnerCompanyAdmins({
        currentPage,
        itemsPerPage,
        ...query,
      });
    }
    handleCancel();
  };

  const handleCancel = () => {
    setState({ ...state, visibleModal: false });
  };

  return (
    <div className="Content PartnerCompanyAdminsPage">
      <div className="ContentHeader">
        <div className="HeaderTitle">Company Admins</div>
        <div className="HeaderToolBar">
          <div className="ToolBarButtons">
            <Button
              className={`FilterButton ${showFilters ? "Open" : "Close"}`}
              type="primary"
              onClick={() => setShowFilters(!showFilters)}>
              Filter <ReactSVG className="icon" src="/icons/filter.svg" />
            </Button>
            <Button
              className="NewButton"
              type="primary"
              onClick={() => {
                handleClickAction("new", null);
              }}>
              New Company Admin
              <ReactSVG className="icon" src="/icons/add.svg" />
            </Button>
          </div>
        </div>
      </div>
      <div className="ContentFilters">
        {showFilters && <CompanyAdminsFilterForm isFetching={isFetching} query={query} onSubmit={handleFilter} />}
      </div>
      <div className="ContentMain">
        <CompanyAdminsTable
          rowKey="_id"
          loading={isFetching}
          query={query}
          withAction={withAction}
          pagination={pagination}
          dataSource={companyAdmins}
          onChange2={handleTableChange}
          scrollHeight="calc(100vh - 285px)"
          actionWidth={70}
        />
      </div>

      <Modal open={state.visibleModal} onCancel={handleCancel} footer={[]} width={370}>
        <CompanyAdminForm
          form={form}
          isFetching={isFetching}
          companyAdmin={state.companyAdmin}
          companies={companies}
          handleSubmit={handleOnFinish}
          handleCancel={handleCancel}
        />
      </Modal>
    </div>
  );
};

export default withPage(ListContainer(PartnerCompanyAdminsPage));
